import { UserModule } from './../../user/user/user.module';
import { PanelModule } from 'primeng-lts/panel';

import { DialogModule } from 'primeng-lts/dialog';
import { TableModule } from 'primeng-lts/table';
import { SubHeaderModule } from './../../components/common/sub-header/sub-header.module';
import { FormPlycaModule } from './../../components/forms/formPlyca.module';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { exportProcessEditionPanelComponent } from './exportProcessEditionPanel.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { exportProcessPanelComponent } from './exportProcessPanel.component';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [exportProcessEditionPanelComponent, exportProcessPanelComponent],
  imports: [
    CommonModule,
    DynamicDialogModule,
    ScrollPanelModule,
    TranslateModule,
    FormPlycaModule,
    SubHeaderModule,
    TableModule,
    DialogModule, PanelModule, UserModule,
    ProgressBarModule

  ]

})
export class ExportProcessPanelModule { }
